export default __webpack_public_path__ + "static/csv/ProductLedHomeTiles.9c19c89a.csv";